import { useEffect, useState } from 'react';
import { Autocomplete, FormControl, FormLabel, FormHelperText } from '@mui/joy';
import { APIGetCabinetAccounts } from '../../api';

export default function CabinetAccountPicker({ token, value, onChange, disabled = false, query, allowUnregistered = false }) {
  const [search, setSearch] = useState(value?.label || '');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [open, setOpen] = useState(false);
  useEffect(() => { setSearch(value?.label || ''); setOpen(false); }, [value?.id]);
  useEffect(() => {
    if (query === undefined || value || disabled) return;
    setSearch(query); setOpen(String(query).trim().length >= 3);
  }, [query, value?.id, disabled]);
  useEffect(() => {
    let cancelled = false;
    setError(''); setOptions([]); setLoading(false);
    if (disabled || search.trim().length < 3 || (value && search === value.label)) return undefined;
    const timer = setTimeout(async () => {
      setLoading(true);
      try { const list = await APIGetCabinetAccounts(token, search.trim()); if (!cancelled) setOptions(list); }
      catch { if (!cancelled) setError('Не удалось найти аккаунты. Повторите поиск.'); }
      finally { if (!cancelled) setLoading(false); }
    }, 300);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [token, search, disabled, value?.id]);
  const items = value && !options.some(o => o.id === value.id) ? [value, ...options] : options;
  return <FormControl error={!!error}>
    <FormLabel>{allowUnregistered ? 'Клиент' : 'Владелец клиентского кабинета'}</FormLabel>
    <Autocomplete value={value || null} inputValue={search} options={items} loading={loading} disabled={disabled}
      open={open && !disabled} onOpen={() => setOpen(true)} onClose={() => setOpen(false)} freeSolo={allowUnregistered}
      getOptionLabel={o => typeof o === 'string' ? o : o.label || `ID ${o.id}`}
      isOptionEqualToValue={(a, b) => a.id === b.id} filterOptions={list => list}
      placeholder="Имя, телефон или email клиента"
      slotProps={{ listbox: { sx: { zIndex: 10220, maxHeight: 260 } } }}
      noOptionsText={loading ? 'Поиск…' : 'Клиент не найден'}
      onInputChange={(_, text, reason) => { if (reason === 'input' || reason === 'clear') {
        setSearch(text); setOpen(text.trim().length >= 3); if (value) onChange(null);
      } }}
      onChange={(_, next) => { onChange(typeof next === 'object' ? next : null); setOpen(false); }} />
    <FormHelperText>{error || (value
      ? 'Заявка появится в выбранном клиентском кабинете. Встречающий на объекте задаётся отдельно.'
      : allowUnregistered ? 'Если клиент не выбран из списка, заявка будет создана без клиентского кабинета. Заполните ФИО и телефон заказчика.'
      : 'Заявка появится в кабинете выбранного аккаунта.')}</FormHelperText>
  </FormControl>;
}
